import { render, staticRenderFns } from "./BuyboxFeature.vue?vue&type=template&id=274b8a0d&"
import script from "./BuyboxFeature.vue?vue&type=script&lang=ts&"
export * from "./BuyboxFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BuyboxFeature.vue"
export default component.exports